import React from 'react';
import { PageHeader } from '../components/Shared';
import { useLang } from '../context/LanguageContext';
import { AdminSessionProvider, useAdminSession } from '../context/AdminSessionContext';
import { AdminLogin } from '../components/admin/AdminLogin';
import { AdminDashboard } from '../components/admin/AdminDashboard';
import { adminCopy } from '../data/admin-copy';

const AdminContent = () => {
  const { lang } = useLang();
  const copy = adminCopy[lang];
  const { status, refresh } = useAdminSession();
  const authenticated = status === 'authenticated';
  return <div><PageHeader eyebrow={copy.eyebrow} title={copy.title} subtitle={authenticated ? copy.subtitle : copy.protected} />
    {status === 'checking' && <p className="site-container loading-line" data-testid="admin-session-checking">{copy.checking}</p>}
    {status === 'error' && <div className="site-container"><p role="alert" data-testid="admin-session-error" className="error-message">{copy.failed}</p><button className="text-button my-5" data-testid="admin-session-retry" onClick={refresh}>{copy.retry}</button></div>}
    {status === 'anonymous' && <AdminLogin copy={copy} />}
    {authenticated && <AdminDashboard copy={copy} lang={lang} />}
  </div>;
};

export default function Admin() {
  return <AdminSessionProvider><AdminContent /></AdminSessionProvider>;
}